import React from 'react'
import { Box } from '../../../core-components/box'

export const Mixed = () => (
  <Box
    as='svg'
    xmlns='http://www.w3.org/2000/svg'
    width='8px'
    height='2px'
    fill='none'
    color='fg/major-on-color'
  >
    <path fill='currentColor' fillRule='evenodd' d='M8 2H0V0h8v2Z' clipRule='evenodd' />
  </Box>
)
